function createUniqueId(prefix = '', suffix = ''): string {
  return (
    prefix +
    Math.random().toString(36).substr(2, 6) +
    new Date().getTime().toString().substr(2, 3) +
    suffix
  );
}
export default createUniqueId;
